import { render, staticRenderFns } from "./AamsUnitBaseCategory.vue?vue&type=template&id=609f32ac&scoped=true&"
import script from "./AamsUnitBaseCategory.vue?vue&type=script&lang=js&"
export * from "./AamsUnitBaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f32ac",
  null
  
)

export default component.exports